<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item :label="$t('views.transportation.form.name')" prop="name" >
        <a-input v-model="form.name" :placeholder="$t('views.transportation.form.namePlaceholder')" />
      </a-form-model-item>
      <a-form-model-item :label="$t('views.transportation.form.nameEn')" prop="nameEn" >
        <a-input v-model="form.nameEn" :placeholder="$t('views.transportation.form.nameEnPlaceholder')" type="textarea" allow-clear />
      </a-form-model-item>
      <a-form-model-item :label="$t('views.transportation.form.shippingCost')" prop="shippingCost" >
        <a-input-number
          v-model="form.shippingCost"
          :min="0"
          :precision="2"
          :step="0.01"
          style="width: 100%;"
          :placeholder="$t('views.transportation.form.shippingCostPlaceholder')"
        />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('views.transportation.form.save') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('views.transportation.form.cancel') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getTransportation, addTransportation, updateTransportation } from '@/api/user/transportation'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        name: null,

        nameEn: null,

        shippingCost: null,

        sort: null,

        status: 1,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
    '$i18n.locale' () {
      if (!this.open) return
      this.formTitle = this.formType === 2
        ? this.$t('views.transportation.title.edit')
        : this.$t('views.transportation.title.add')
    }
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        name: null,
        nameEn: null,
        shippingCost: null,
        sort: null,
        status: 1,
        createTime: null,
        remark: null,
      }
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('views.transportation.title.add')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getTransportation({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('views.transportation.title.edit')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateTransportation(this.form).then(response => {

              if(response.success) {
                this.$message.success(this.$t('views.transportation.msg.updateOk'), 3)
                this.open = false
                this.$emit('ok')
              } else {
                let messageInfo = response.message || response.msg || this.$t('views.transportation.msg.updateFail')
                this.$message.error(messageInfo);
              }

            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addTransportation(this.form).then(response => {
              if(response.success) {
                this.$message.success(this.$t('views.transportation.msg.addOk'), 3)
                this.open = false
                this.$emit('ok')
              } else {
                let messageInfo = response.message || response.msg || this.$t('views.transportation.msg.addFail')
                this.$message.error(messageInfo);
              }

            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
